export function legacyDropDownDataContext(this: any, config: any) {
  return {
    isOpen: false,
    toggle($event) {
      $event?.preventDefault();
      this.isOpen = !this.isOpen;
    },
  };
}
